import ReportPage from './ReportPage'

export default function DistribuidorPrioritarioReport({className = ''}: {className?: string}) {
  return <ReportPage type='distribuidor_prioritario' className={className} />
}
